var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "module-container" } }, [
    _c("div", { attrs: { id: "module-left" } }, [
      _c("i", {
        class:
          _vm.thumb === 1
            ? "iconfont el-icon-ipf-right thumb"
            : "iconfont el-icon-ipf-left thumb",
        attrs: {
          id: "module-container-thumb",
          title: _vm.thumb === 1 ? "展开菜单栏" : "折叠菜单栏",
        },
        on: { click: _vm.setThumb },
      }),
      _vm._v(" " + _vm._s(_vm.date) + " "),
    ]),
    _c(
      "div",
      { attrs: { id: "module" } },
      [
        _vm._l(_vm.menus, function (menu) {
          return _vm.filterMenu(menu)
            ? [
                _c(
                  "div",
                  {
                    key: menu.id,
                    staticClass: "item",
                    class: { selected: _vm.selectedId === menu.id },
                    on: {
                      click: function ($event) {
                        return _vm.jump(menu)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(menu.name) + " ")]
                ),
              ]
            : _vm._e()
        }),
      ],
      2
    ),
    _c("div", { attrs: { id: "module-right" } }),
    _c("div", { staticClass: "clear" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }